import * as React from "react";
import { ZOption } from "src/types/ZOption";

import { ColumnFilterDef } from "./ColumnFilterDef";
import { MultiSelectDropdownFilter } from "./MultiSelectDropdownFilter";

export const multiSelectColumnFilter = (params: {
  getValues: () => string[] | undefined;
  setValues: (values: string[] | undefined) => void;
  options: ZOption[]; // В дальнейшем нужно будет добавить вариант для асинхронной загрузки опций
}): ColumnFilterDef => ({
  getValue: (): string[] | undefined => params.getValues(),
  render: (props) => (
    <MultiSelectDropdownFilter
      currentValue={params.getValues()}
      apply={(values) => {
        props.confirm();
        props.setSelectedKeys(values ?? []);
        params.setValues(
          Array.isArray(values) && values.length === 0 ? undefined : values,
        );
      }}
      cancel={() => props.close()}
      options={params.options}
    />
  ),
});
